module.exports = __webpack_public_path__ + "img/symbol_6.5c3aad4e.png";